import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription, take } from 'rxjs';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

import { DietService } from 'src/app/services/diet.service';
import { FoodOptionService } from 'src/app/services/food-option.service';
import { StorageService } from 'src/app/services/storage.service';
import { StateService } from 'src/app/services/state.service';
import { ToastService } from 'src/app/services/toast.service';

import { Diet } from 'src/app/interfaces/diet';
import { User } from 'src/app/interfaces/user';

import { Modal } from 'bootstrap';

@Component({
  selector: 'app-diet',
  templateUrl: './diet.component.html',
  styleUrls: ['./diet.component.scss'],
})
export class DietComponent implements OnInit, OnDestroy {
  @ViewChild('dietFormModal') dietModal: ElementRef | undefined;
  @ViewChild('mealModal') mealModal: ElementRef | undefined;

  user: User | undefined;
  diets: Diet[] = [];

  selectedDiet: Diet | undefined;
  openAccordionId: number | null = null; // Track which accordion item is open

  firstCopy = false;

  subs = new Subscription();

  constructor(
    private dietService: DietService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private storageService: StorageService,
    private stateService: StateService,
    private foodOptionService: FoodOptionService
  ) {}

  ngOnInit(): void {
    dayjs.extend(utc);
    this.user = this.storageService.get('selectedUser');

    this.getUserDietsHistory();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // Custom Accordion Methods
  isAccordionOpen(dietId: number): boolean {
    return this.openAccordionId === dietId;
  }

  toggleAccordion(dietId: number): void {
    if (this.openAccordionId === dietId) {
      // Close the accordion if it's already open
      this.openAccordionId = null;
      this.selectedDiet = undefined;
    } else {
      // Open the accordion and set the selected diet
      this.openAccordionId = dietId;
      this.openAccordionItem(dietId);
    }
  }

  openAccordionItem(dietId: number) {
    if (dietId === this.selectedDiet?.id) return;

    this.selectedDiet = this.diets.find((diet) => diet.id == dietId)!;
    // this.getMealsFromDiet(dietId);
  }

  // CRUD Diets:

  handleCreateDiet(event: Event) {
    if (this.diets.length > 0 && this.diets[0].activeDiets !== null) {
      // Check if confirm returns true (OK button)
      const confirmCreate = confirm(
        'Ya existe una dieta en este momento. Quieres que esta nueva dieta sea complementativa a la anterior?'
      );

      if (confirmCreate) {
        // User confirmed, prepare for modal
        this.createDiet();
      }
      // If user cancels, do nothing
    } else {
      this.createDiet();
    }
  }

  openModal() {
    setTimeout(() => {
      const modalElement = document.getElementById('dietFormModal');
      console.log(modalElement);
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
      }
    }, 100);
  }

  createDiet() {
    this.selectedDiet = undefined; // Clear selected diet for new creation
    this.stateService.updateEdition(false);
  }

  editDiet(diet: Diet) {
    this.selectedDiet = diet; // Set the diet to be edited
    this.stateService.updateEdition(true);
  }

  getUserDietsHistory() {
    const userId = this.route.snapshot.paramMap.get('userId')!;

    this.subs.add(
      this.dietService.getUserDietHistory(userId).subscribe({
        next: (response: any) => {
          if (!response.diets) {
            this.diets = [];
            return;
          }

          this.diets = response.diets;

          this.diets.forEach((diet: Diet) => {
            const finishedAtDate = dayjs(diet.finishedAt).utc();
            diet.parsedFinishAt = `${finishedAtDate
              .get('date')
              .toString()
              .padStart(2, '0')}/${(finishedAtDate.get('month') + 1)
              .toString()
              .padStart(2, '0')}/${finishedAtDate.get('year')}`;

            const startedAtDate: dayjs.Dayjs = dayjs(diet.startAt).utc();

            diet.parsedStartAt = `${startedAtDate
              .get('date')
              .toString()
              .padStart(2, '0')}/${(startedAtDate.get('month') + 1)
              .toString()
              .padStart(2, '0')}/${startedAtDate.get('year')}`;

            // this.getMealsFromDiet(this.diets[0].id);
          });
        },
        error: (error) => {
          this.toastService.alert(error.messageError);
        },
      })
    );
  }

  onDietCreate(diet: Diet) {
    this.getUserDietsHistory();
  }
}
